import {RecodeGameAutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/recode/RecodeGameAutoplayHandlerModule';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';

export class GameAutoplayHandlerModule extends RecodeGameAutoplayHandlerModule {

	protected onSpinEnded(): void {
		const logic: GameRecodeLogic = this.logic as GameRecodeLogic;

		if (this._isEnabled) {
			this._totalAutoplayWin += logic.getTransTotalWin();
			this._winAmount = logic.getTransTotalWin();
		}
	}

	public bigWinUpdate(): void {
		const logic: GameRecodeLogic = this.logic as GameRecodeLogic;

		this._isWinBigWin = true;

		this._totalAutoplayWin += logic.getTransTotalWin();
		this._winAmount = logic.getTransTotalWin();
	}

	public winUpdate(): void {
		const logic: GameRecodeLogic = this.logic as GameRecodeLogic;

		if (!this._isWinBigWin) {
			this._totalAutoplayWin += logic.getTransTotalWin();
			this._winAmount = logic.getTransTotalWin();
		} else {
			this._isWinBigWin = false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/autoplay/GameAutoplayHandlerModule.ts